<template>
  <transition name="in">
    <div class="hint" ontouchmove="return false" @click="handler(3)">
      <div class="body" @click.stop>
        <p class="tit">温馨提示</p>
        <div class="last-now-box">
          <div class="last-box">
            <p class="price">¥{{hintInfo.now}}</p>
            <p class="txt">以下可用</p>
            <p class="tip">{{year}}年免费机票</p>
          </div>
          <div class="now-box">
            <p class="price">¥{{hintInfo.next}}</p>
            <p class="txt">以下可用</p>
            <p class="tip">{{year}}年免费机票</p>
          </div>
          <img class="to" src="//file.40017.cn/appresource/image/tin1/icon_up.png">
        </div>
        <p class="tips">再完成1次满￥{{hintInfo.spread}}飞行可提升权益等级<br>请确认是否直接兑换当前权益？</p>
        <div class="btn-box">
          <p class="change" @click="handler(1)">直接兑换</p>
          <p class="again" @click="handler(2)">再来一单</p>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['hintinfo'],
  computed: {
    year() {
      return new Date().getFullYear()
    },
    hintInfo() {
      return JSON.parse(this.hintinfo)
    }
  },
  methods: {
    handler(type) {
      this.$emit('handler', type)
    }
  }
}
</script>
<style lang="less" scoped>
.hint {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  .body {
    width: 300px;
    height: 361px;
    background: url('//file.40017.cn/appresource/image/tin1/bg_popups.png') no-repeat top center;
    background-size: cover;
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
    -webkit-transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    .tit {
      padding-top: 20px;
      line-height: 24px;
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
    .last-now-box {
      display: -webkit-box;
      -webkit-box-align: end;
      text-align: center;
      padding: 20px 17px 0;
      position: relative;
      .last-box {
        width: 113px;
        height: 104px;
        background: url('//file.40017.cn/appresource/image/tin1/bg_popups_small.png') no-repeat center center;
        background-size: contain;
        .price {
          padding-top: 22px;
          font-size: 16px;
          line-height: 19px;
          color: #247bff;
          font-weight: bold;
        }
        .txt {
          font-size: 12px;
          padding-top: 5px;
          line-height: 14px;
          color: #247bff;
        }
        .tip {
          color: #37383d;
          font-size: 10px;
          line-height: 12px;
          margin-top: 16px;
        }
      }
      .now-box {
        width: 128px;
        height: 131px;
        background: url('//file.40017.cn/appresource/image/tin1/bg_popups_big.png') no-repeat center center;
        background-size: contain;
        margin-left: 26px;
        .price {
          padding-top: 26px;
          font-size: 22px;
          line-height: 24px;
          color: #247bff;
          font-weight: bold;
        }
        .txt {
          font-size: 12px;
          padding-top: 5px;
          line-height: 14px;
          color: #247bff;
        }
        .tip {
          color: #37383d;
          font-size: 12px;
          line-height: 14px;
          margin-top: 31px;
        }
      }
      .to {
        width: 22px;
        height: 21px;
        position: absolute;
        left: 132px;
        top: 80px;
      }
    }
    .tips {
      font-size: 14px;
      color: #37383d;
      line-height: 24px;
      margin-top: 19px;
    }
    .btn-box {
      display: -webkit-box;
      -webkit-box-pack: center;
      margin-top: 32px;
      .change {
        width: 116px;
        height: 42px;
        line-height: 42px;
        border: 1px solid #247bff;
        color: #247bff;
        text-align: center;
        font-size: 16px;
        border-radius: 4px;
      }
      .again {
        width: 116px;
        height: 42px;
        line-height: 42px;
        border: 1px solid #247bff;
        color: #fff;
        font-size: 16px;
        background: #247bff;
        text-align: center;
        border-radius: 4px;
        margin-left: 14px;
        font-weight: bold;
      }
    }
  }
}
.in-enter,
.in-leave-to {
  opacity: 0;
}

.in-enter-active,
.in-leave-active {
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
}
</style>